export const NOTIFICATION_TOKEN = "NOTIFICATION_TOKEN";
